<div class="mimic-roles-main">
    <mat-form-field>
        <mat-label>Select Role To Mimic</mat-label>
        <mat-select [(value)]="selectedRole" (valueChange)="mimicRole()">
            <mat-option value="SUPPORT">Support</mat-option>
            <mat-option value="GA_EDITOR">Geographic Area Editor</mat-option>
            <mat-option value="ANALYST">Fire Behavior Analyst</mat-option>
            <mat-option value="INCIDENT_EDITOR">Editor</mat-option>
            <mat-option value="WFDSS_VIEWER">Viewer</mat-option>
        </mat-select>
    </mat-form-field>
</div>
